<template>
    <div class="video">
        <video ref="video" :src="src" :poster="poster" loop :muted="muted" :controls="!muted" playsinline preload="metadata"></video>
    </div>
</template>

<style lang="scss" scoped>
    // see /static/scss/components/_circles.scss
</style>

<script>
    export default {
        name: 'Video',

        props: {
            src: {
                type: String,
                default: ''
            },
            poster: {
                type: String,
                default: ''
            },
            loop: {
                type: Boolean,
                default: true
            },
            muted: {
                type: Boolean,
                default: true
            }
        },

        data()
        {
            return {
                ready: false,
                requestedToPlay: false
            };
        },

        mounted()
        {
            this.$refs.video.addEventListener( 'canplaythrough', this.videoCanPlayHandler.bind( this ) );
            this.$refs.video.load();
        },

        methods: {
            play()
            {
                if( this.ready )
                {
                    this.$refs.video.currentTime = 0;
                    this.$refs.video.play();
                }
                else
                {
                    this.requestedToPlay = true;
                }
            },

            pause()
            {
                this.requestedToPlay = false;
                this.$refs.video.pause();
            },

            videoCanPlayHandler()
            {
                if( this.ready )
                {
                    return;
                }

                this.ready = true;

                if( this.requestedToPlay )
                {
                    this.play();
                }
            }
        }
    };
</script>
